import { initialState } from ".";
import { axios_server } from "../backend";
import { Action, Store } from "../decleration";
import { removeAuthCookies } from "../helpers";
export enum Actions {
  LOGIN = "LOGIN",
  LOGOUT = "LOGOUT",
  AUTHENTICATE = "AUTHENTICATE",
  PERSIST = "PERSIST",
  REFRESH_TOKEN = "REFRESH_TOKEN",
  CHECK_USER = "CHECK_USER",
  UPDATE_ALL = "UPDATE_ALL",
  LOGID = "LOGID",
  SNACKBAR = "SNACKBAR",
  TOGGLETHEME = "TOGGLETHEME",
}

const Reducer = (state: Store, action: Action) => {
  switch (action.type) {
    case Actions.AUTHENTICATE:
      axios_server.defaults.headers.common["Authorization"] =
        `Bearer ${action.payload?.access_token}`;
      return {
        ...state,
        user: {
          ...action.payload,
        },
      };
    case Actions.TOGGLETHEME:
      return {
        ...state,
        theme: action.payload,
      };
    case Actions.LOGID:
      return {
        ...state,
        log: action.payload,
      };
    case Actions.SNACKBAR: {
      return {
        ...state,
        snackbar: action.payload,
      };
    }
    case Actions.LOGOUT:
      delete axios_server.defaults.headers.common["Authorization"];
      removeAuthCookies();
      if (typeof window !== "undefined") {
        window.localStorage.clear();
        return { ...initialState };
      }
    case Actions.UPDATE_ALL:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export { Reducer };
